// // DailyPortfolioAccrual.jsx
// import React, { useState } from "react";
// import { Modal } from "react-bootstrap";
// import {
//   Container,
//   Row,
//   Col,
//   Button,
//   Card,
//   CardHeader,
//   CardBody,
//   Table,
// } from "reactstrap";
// import Select from "react-select";
// import moment from "moment";
// import { ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { useCustomStylesDropDown } from "../assets/css/customStyle";
// import NumberFormat from "react-number-format";
// import ReactTooltip from "react-tooltip";
// import { useSelector } from "react-redux";
// import { SecurityArr } from "../utils/ui_data";
// import usePortfolioAccrual from "./daily-fund-accrual/usePortfolioAccural";

// const DailyPortfolioAccrual = () => {
//   const email = sessionStorage.getItem("email") || "";
//   const amc_code = sessionStorage.getItem("amc_code") || "";
//   const {
//     loading,
//     accFundLoading,
//     allFunds,
//     fund,
//     setFund,
//     date,
//     portfolioDate,
//     handleDateChange,
//     tableData,
//     calculations,
//     affectedLedgerData,
//     sendingLedgers,
//     fundCheck,
//     todayPIBTotal,
//     todayTBILLTotal,
//     todayTFCTotal,
//     todaySUKUKTotal,
//     finalPIB,
//     finalTBILL,
//     finalTFC,
//     finalSUKUK,
//     handleGet,
//     resetState,
//     selectedMarketVal,
//     setSelectedMarket,
//     selectedMarket,
//     handleSubmit,
//     renderFundsDropdown,
//     selectedFundName,
//     numberWithCommas,
//     updateCouponRate,
//     removeSecurityAtIndex,
//     handlePortfolioDate,
//   } = usePortfolioAccrual(email, amc_code);
//   const theme = useSelector((state: any) => state.ThemeModeReducer.Theme);

//   const disableCoupanRateArr = ["PIB", "TBILL", "TDR", "LOP", "CP", "CDR"];

//   const { customStyles } = useCustomStylesDropDown();

//   const StockMarketData = () => {
//     return (
//       <Table responsive>
//         <thead className="text-nowrap">
//           <tr>
//             <td colSpan={4}>Fund Code: &nbsp; &nbsp; {fund}</td>
//             <td colSpan={4}>AMC Code: &nbsp; &nbsp; {amc_code}</td>
//           </tr>
//           <tr>
//             <th>Code</th>
//             <th>Market</th>
//             <th className="text-right">Amount</th>
//             <th className="text-right">Average Cost/Unit</th>
//             <th className="text-right">Investment Percentage Market Value</th>
//             <th className="text-right">Market Rate/Unit</th>
//             <th className="text-right">Market Value</th>
//             <th className="text-right">Total Units</th>
//             <th className="text-right">Unit</th>
//             <th className="text-right">Unrealized Gain Loss</th>
//           </tr>
//         </thead>
//         <tbody>
//           {tableData.map((data: any, index) => (
//             <tr key={index} className="text-nowrap">
//               <td>{data?.code}</td>
//               <td>{data?.market}</td>
//               <td className="text-right">
//                 {numberWithCommas(parseFloat(data?.amount || 0).toFixed(4))}
//               </td>

//               <td className="text-right">
//                 {numberWithCommas(
//                   parseFloat(data?.average_cost_per_unit || 0).toFixed(4)
//                 )}
//               </td>
//               <td className="text-right">
//                 {numberWithCommas(
//                   parseFloat(
//                     data?.investment_percentage_market_value || 0
//                   )?.toFixed(4)
//                 )}
//               </td>
//               <td className="text-right">
//                 {numberWithCommas(
//                   parseFloat(data?.market_rate_per_unit || 0)?.toFixed(4)
//                 )}
//               </td>
//               <td className="text-right">
//                 {numberWithCommas(
//                   parseFloat(data?.market_value || 0).toFixed(4)
//                 )}
//               </td>
//               <td className="text-right">
//                 {numberWithCommas(
//                   parseFloat(data?.total_units || 0).toFixed(4)
//                 )}
//               </td>
//               <td className="text-right">
//                 {numberWithCommas(parseFloat(data?.unit || 0).toFixed(4))}
//               </td>
//               <td className="text-right">
//                 {numberWithCommas(
//                   parseFloat(data?.unrealized_gain_loss || 0).toFixed(4)
//                 )}
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </Table>
//     );
//   };

//   const [modalViewMM, setModalViewMM] = useState(false);
//   const [selectedItem, setSelectedItem] = useState<any>();

//   return (
//     <>
//       <ToastContainer />
//       <div className="content">
//         {/* --------------------- Modal to View All Details MM ------------------- */}
//         <Modal
//           className=""
//           dialogClassName="modal90w"
//           show={modalViewMM}
//           size="lg"
//           backdrop={true}
//           onHide={() => {
//             setModalViewMM(false);
//           }}
//         >
//           <div className="modal-header ">
//             <button
//               aria-hidden={true}
//               className="close"
//               data-dismiss="modal"
//               type="button"
//               onClick={() => {
//                 setModalViewMM(false);
//               }}
//             >
//               <i className="tim-icons icon-simple-remove" />
//             </button>
//             <h6 className="title title-up">View Money Market Security</h6>
//           </div>
//           <div className="modal-header ">
//             <button
//               aria-hidden={true}
//               className="close"
//               data-dismiss="modal"
//               type="button"
//               onClick={() => {
//                 setModalViewMM(false);
//               }}
//             >
//               <i className="tim-icons icon-simple-remove" />
//             </button>
//             {/* <h6 className="title title-up">View Security  </h6> */}
//           </div>
//           <div className="modal-body">
//             {selectedItem && (
//               <div>
//                 <table className="table ">
//                   <tbody>
//                     <tr>
//                       <td
//                         className="font-weight-bold text-left"
//                         style={{ width: "25%" }}
//                       >
//                         Security Type:
//                       </td>
//                       <td>{selectedItem.security_type}</td>
//                     </tr>
//                     <tr>
//                       <td className="font-weight-bold text-left">
//                         Investment Type:
//                       </td>
//                       <td>{selectedItem.investment_type}</td>
//                     </tr>
//                     <tr>
//                       <td className="font-weight-bold text-left">Type:</td>
//                       <td>{selectedItem.type}</td>
//                     </tr>
//                     <tr>
//                       <td className="font-weight-bold text-left">Symbol:</td>
//                       <td>{selectedItem.symbol}</td>
//                     </tr>
//                     <tr>
//                       <td className="font-weight-bold text-left">Name:</td>
//                       <td>{selectedItem.name}</td>
//                     </tr>
//                     <tr>
//                       <td className="font-weight-bold text-left">
//                         Issue Date:
//                       </td>
//                       <td>
//                         {selectedItem.issue_date
//                           ? moment(selectedItem.issue_date).format("DD-MM-YYYY")
//                           : ""}
//                       </td>
//                     </tr>
//                     <tr>
//                       <td className="font-weight-bold text-left">
//                         Maturity Date:
//                       </td>
//                       <td>
//                         {selectedItem.maturity_date
//                           ? moment(selectedItem.maturity_date).format(
//                               "DD-MM-YYYY"
//                             )
//                           : ""}
//                       </td>
//                     </tr>
//                     <tr>
//                       <td className="font-weight-bold text-left">
//                         Face Value:
//                       </td>
//                       <td>
//                         {numberWithCommas(
//                           Number(
//                             selectedItem?.money_market_face_value || 0
//                           ).toFixed(2)
//                         )}
//                         {/* {numberWithCommas(selectedItem.money_market_face_value || 0)} */}
//                       </td>
//                     </tr>
//                     <tr>
//                       <td className="font-weight-bold text-left">Price:</td>
//                       <td>
//                         {numberWithCommas(
//                           Number(selectedItem?.price || 0).toFixed(2)
//                         )}
//                         {/* {selectedItem.price === undefined
//                                   ? "0"
//                                   : numberWithCommas(selectedItem.price || 0)} */}
//                       </td>
//                     </tr>
//                     <tr>
//                       <td className="font-weight-bold text-left">Units:</td>
//                       <td>
//                         {numberWithCommas(
//                           Number(selectedItem?.units || 0).toFixed(4)
//                         )}
//                         {/* {selectedItem.units === undefined
//                                   ? "0"
//                                   : numberWithCommas(selectedItem.units || 0)} */}
//                       </td>
//                     </tr>
//                     <tr>
//                       <td className="font-weight-bold text-left">Yield:</td>
//                       <td>
//                         {numberWithCommas(
//                           Number(selectedItem?.yield || 0).toFixed(2)
//                         )}
//                         {/* {selectedItem.yield === undefined
//                                   ? "0"
//                                   : numberWithCommas(selectedItem.yield || 0)} */}
//                       </td>
//                     </tr>
//                     <tr>
//                       <td className="font-weight-bold text-left">
//                         Coupon Rate:
//                       </td>
//                       <td>
//                         {numberWithCommas(
//                           Number(selectedItem?.coupon_rate || 0).toFixed(2)
//                         )}
//                         {/* {selectedItem.coupon_rate === undefined
//                                   ? "0"
//                                   : numberWithCommas(selectedItem.coupon_rate || 0)} */}
//                       </td>
//                     </tr>
//                     <tr>
//                       <td className="font-weight-bold text-left">
//                         Next Coupon Date:
//                       </td>
//                       <td>
//                         {selectedItem.next_coupon_date === ""
//                           ? ""
//                           : moment(selectedItem.next_coupon_date).format(
//                               "DD-MM-YYYY"
//                             )}
//                       </td>
//                     </tr>
//                     <tr>
//                       <td className="font-weight-bold text-left">
//                         Last Coupon Date:
//                       </td>
//                       <td>
//                         {selectedItem.last_coupon_date === ""
//                           ? ""
//                           : moment(selectedItem.last_coupon_date).format(
//                               "DD-MM-YYYY"
//                             )}
//                       </td>
//                     </tr>
//                     <tr>
//                       <td className="font-weight-bold text-left">
//                         Primary Dealer:
//                       </td>
//                       <td>{selectedItem.primary_dealer}</td>
//                     </tr>
//                     <tr>
//                       <td className="font-weight-bold text-left">
//                         Fund IPS Account:
//                       </td>
//                       <td>{selectedItem.fund_ips_account}</td>
//                     </tr>
//                     <tr>
//                       <td className="font-weight-bold text-left">
//                         Counter Party IPS Account:
//                       </td>
//                       <td>{selectedItem.counter_party_ips_account}</td>
//                     </tr>
//                     <tr>
//                       <td className="font-weight-bold text-left">
//                         Broker Name:
//                       </td>
//                       <td>{selectedItem.broker_name}</td>
//                     </tr>
//                     <tr>
//                       <td className="font-weight-bold text-left">
//                         Settlement Amount:
//                       </td>
//                       <td>
//                         {numberWithCommas(
//                           Number(selectedItem?.settlement_amount || 0).toFixed(
//                             2
//                           )
//                         )}
//                         {/* {selectedItem.settlement_amount === undefined
//                                   ? "0"
//                                   : numberWithCommas(selectedItem.settlement_amount || 0)} */}
//                       </td>
//                     </tr>
//                     <tr>
//                       <td className="font-weight-bold text-left">
//                         Total Face Value:
//                       </td>
//                       <td>
//                         {numberWithCommas(
//                           Number(selectedItem?.total_face_value || 0).toFixed(2)
//                         )}
//                         {/* {numberWithCommas(selectedItem.total_face_value || 0)} */}
//                       </td>
//                     </tr>
//                     <tr>
//                       <td className="font-weight-bold text-left">
//                         Accrued Amount:
//                       </td>
//                       <td>
//                         {numberWithCommas(
//                           Number(selectedItem?.accrued_amount || 0).toFixed(2)
//                         )}
//                         {/* {selectedItem.accrued_amount === undefined
//                                     ? "0"
//                                     : numberWithCommas(selectedItem.accrued_amount || 0)} */}
//                       </td>
//                     </tr>
//                     <tr>
//                       <td className="font-weight-bold text-left">Brokerage:</td>
//                       <td>{selectedItem.brokerage}</td>
//                     </tr>
//                     <tr>
//                       <td className="font-weight-bold text-left">
//                         Premium Discount:
//                       </td>
//                       <td>
//                         {numberWithCommas(
//                           Number(selectedItem?.premium_discount || 0).toFixed(2)
//                         )}
//                         {/* {numberWithCommas(selectedItem.premium_discount || 0)} */}
//                       </td>
//                     </tr>
//                     <tr>
//                       <td className="font-weight-bold text-left">
//                         Accrued Days:
//                       </td>
//                       <td>{selectedItem.accrued_days}</td>
//                     </tr>
//                     <tr>
//                       <td className="font-weight-bold text-left">
//                         Counter Party Name:
//                       </td>
//                       <td>{selectedItem.counter_party_name}</td>
//                     </tr>
//                     <tr>
//                       <td className="font-weight-bold text-left">Detail:</td>
//                       <td>{selectedItem.detail}</td>
//                     </tr>
//                     <tr>
//                       <td className="font-weight-bold text-left">
//                         Principal Amount:
//                       </td>
//                       <td>
//                         {numberWithCommas(
//                           Number(selectedItem?.principal_amount || 0).toFixed(2)
//                         )}
//                         {/* {selectedItem.principal_amount === undefined
//                                     ? "0"
//                                     : numberWithCommas(selectedItem.principal_amount || 0)} */}
//                       </td>
//                     </tr>
//                     <tr>
//                       <td className="font-weight-bold text-left">
//                         UnRedeem Value:
//                       </td>
//                       <td>
//                         {numberWithCommas(
//                           Number(selectedItem?.unredeem_value || 0).toFixed(2)
//                         )}
//                         {/* {numberWithCommas(selectedItem.unredeem_value || 0)} */}
//                       </td>
//                     </tr>
//                     <tr>
//                       <td className="font-weight-bold text-left">
//                         Coupon Payment/Year:
//                       </td>
//                       <td>
//                         {numberWithCommas(
//                           Number(selectedItem?.coupon_payment || 0).toFixed(2)
//                         )}
//                         {/* {numberWithCommas(selectedItem.coupon_payment || 0)} */}
//                       </td>
//                     </tr>
//                     <tr>
//                       <td className="font-weight-bold text-left">
//                         Days of Maturity:
//                       </td>
//                       {/* <td>{selectedItem.days_of_maturity}</td> */}
//                       <td>{selectedItem?.daysofMaturity || 0}</td>
//                     </tr>
//                     <tr>
//                       <td className="font-weight-bold text-left">
//                         Avg Cost/Unit:
//                       </td>
//                       <td>
//                         {numberWithCommas(
//                           Number(
//                             selectedItem?.average_cost_per_unit || 0
//                           ).toFixed(4)
//                         )}
//                         {/* {numberWithCommas(selectedItem.average_cost_per_unit || 0)} */}
//                       </td>
//                     </tr>
//                     <tr>
//                       <td className="font-weight-bold text-left">
//                         Avg Cost Amt:
//                       </td>
//                       <td>
//                         {numberWithCommas(
//                           Number(
//                             selectedItem?.average_cost_amount || 0
//                           ).toFixed(2)
//                         )}
//                         {/* {numberWithCommas(selectedItem.average_cost_amount || 0)} */}
//                       </td>
//                     </tr>
//                     <tr>
//                       <td className="font-weight-bold text-left">
//                         Gain/Loss Per Unit:
//                       </td>
//                       <td>
//                         {numberWithCommas(
//                           Number(selectedItem?.gain_loss_per_unit || 0).toFixed(
//                             4
//                           )
//                         )}
//                         {/* {numberWithCommas(selectedItem.gain_loss_per_unit || 0)} */}
//                       </td>
//                     </tr>
//                     <tr>
//                       <td className="font-weight-bold text-left">
//                         Gain/Loss Amt:
//                       </td>
//                       <td>
//                         {numberWithCommas(
//                           Number(selectedItem?.gain_loss_amount || 0).toFixed(2)
//                         )}
//                       </td>
//                     </tr>
//                   </tbody>
//                 </table>
//               </div>
//             )}
//           </div>
//         </Modal>

//         <Row>
//           <Col md="12">
//             <Container fluid>
//               <Card className="mt-3">
//                 <CardHeader>
//                   <h4 className="card-title text-primary">
//                     Daily Portfolio Accrual
//                   </h4>
//                 </CardHeader>
//                 <CardBody>
//                   <Row>
//                     <Col md="4">
//                       <label htmlFor="fund">Select Fund</label>
//                       {accFundLoading ? (
//                         <div className="form-control w-100">
//                           <i className="fa fa-spinner fa-spin fa-1x"></i>
//                           Fetching Funds...
//                         </div>
//                       ) : (
//                         <Select
//                           className="react-select info"
//                           classNamePrefix="react-select"
//                           options={renderFundsDropdown}
//                           value={selectedFundName}
//                           onChange={(selectedOption) => {
//                             setSelectedMarket("");
//                             setFund(selectedOption?.value || "");
//                           }}
//                           isLoading={accFundLoading}
//                           isDisabled={accFundLoading || fundCheck}
//                           isClearable={true}
//                           styles={customStyles}
//                         />
//                       )}
//                       {fundCheck && (
//                         <p className="text-danger">No funds available.</p>
//                       )}
//                     </Col>
//                     <Col md="4">
//                       <label htmlFor="fund">Select Market</label>
//                       <Select
//                         className="react-select info"
//                         classNamePrefix="react-select"
//                         options={SecurityArr}
//                         value={selectedMarketVal}
//                         onChange={(selectedOption) => {
//                           resetState();
//                           setSelectedMarket(selectedOption?.value || "");
//                         }}
//                         // isDisabled={fund}
//                         isClearable={true}
//                         styles={customStyles}
//                       />
//                     </Col>
//                     <Col md="4">
//                       <label htmlFor="date">Settlement Date</label>
//                       <input
//                         style={{
//                           colorScheme: theme,
//                         }}
//                         type="date"
//                         className="form-control"
//                         value={date}
//                         onChange={handleDateChange}
//                         max={moment().format("YYYY-MM-DD")}
//                       />
//                     </Col>
//                     <Col md="4">
//                       <label htmlFor="date">Portfolio Date</label>
//                       <input
//                         type="date"
//                         style={{
//                           colorScheme: theme,
//                         }}
//                         className="form-control"
//                         value={portfolioDate}
//                         onChange={handlePortfolioDate}
//                         max={moment().format("YYYY-MM-DD")}
//                       />
//                     </Col>
//                     <Col md="4" className="mt-4">
//                       <Button
//                         className="btn btn-primary"
//                         onClick={handleGet}
//                         disabled={
//                           loading || accFundLoading || !fund || !selectedMarket
//                         }
//                       >
//                         {loading ? (
//                           <>
//                             <span
//                               className="spinner-border login-txt spinner-border-sm"
//                               role="status"
//                               aria-hidden="true"
//                             ></span>
//                             <span className="login-txt"> Loading...</span>
//                           </>
//                         ) : (
//                           <span className="text-white">Get Portfolio</span>
//                         )}
//                       </Button>
//                     </Col>
//                   </Row>
//                 </CardBody>
//               </Card>
//               {tableData.length > 0 && (
//                 <Card className="mt-3">
//                   <CardHeader>
//                     <h4 className="card-title text-primary">
//                       Today {moment().format("YYYY-MM-DD")}
//                     </h4>
//                   </CardHeader>
//                   <CardBody>
//                     {selectedMarket === "money_market" ? (
//                       <Table responsive>
//                         <thead className="text-nowrap">
//                           <tr>
//                             <td colSpan={4}>Fund Code: &nbsp; &nbsp; {fund}</td>
//                             <td colSpan={4}>
//                               AMC Code: &nbsp; &nbsp; {amc_code}
//                             </td>
//                           </tr>
//                           <tr>
//                             <th>Symbol</th>
//                             <th>Security Type</th>
//                             <th>Name</th>
//                             <th>Issue Date</th>
//                             <th>Maturity Date</th>
//                             <th className="text-right">Units</th>
//                             <th align="right">Total Face Value</th>
//                             <th align="right">Principal Amount</th>
//                             <th align="right">Total Cost</th>
//                             <th align="right">Unredeem Value</th>
//                             <th align="right">Maturity Days</th>
//                             <th align="right">Coupon Days</th>
//                             <th align="right">Coupon Payment</th>
//                             <th align="right">Yield %</th>
//                             <th align="right">Coupon Rate %</th>
//                             {/* <th align="right">MM Face Value / Unit</th> */}
//                             {/* <th align="right">Avg Cost / Unit</th> */}
//                             {/* <th align="right">Market Rate / Unit</th> */}
//                             {/* <th align="right">Market Value</th> */}
//                             {/* <th align="right">Unrealized Gain / (Loss)</th> */}
//                             {/* <th align="right">Investment % of Market Value</th> */}
//                             <th align="center">Action</th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {tableData.map((data: any, index) => {
//                             const maturityMoment = moment(
//                               data?.maturity_date
//                             ).startOf("day");
//                             const currentMoment = moment(date).startOf("day");

//                             const daysofMaturity = maturityMoment.diff(
//                               currentMoment,
//                               "days"
//                             );
//                             return (
//                               <tr key={index} className="text-nowrap">
//                                 <td>{data?.code}</td>
//                                 <td>{data?.security_type}</td>
//                                 <td>
//                                   <ReactTooltip
//                                     textColor="white"
//                                     backgroundColor="black"
//                                     effect="float"
//                                   />
//                                   <div
//                                     data-tip={data?.name}
//                                     style={{
//                                       maxWidth: "80px",
//                                     }}
//                                     className="text-truncate"
//                                   >
//                                     {data?.name}
//                                   </div>
//                                 </td>
//                                 <td>{data?.issue_date}</td>
//                                 <td>{data?.maturity_date}</td>
//                                 <td align="right">
//                                   {numberWithCommas(
//                                     parseFloat(data?.units || 0).toFixed(4)
//                                   )}
//                                 </td>
//                                 <td align="right">
//                                   {numberWithCommas(
//                                     parseFloat(
//                                       data?.total_face_value || 0
//                                     ).toFixed(4)
//                                   )}
//                                 </td>
//                                 <td align="right">
//                                   {numberWithCommas(
//                                     parseFloat(
//                                       data?.principal_amount || 0
//                                     )?.toFixed(4)
//                                   )}
//                                 </td>
//                                 <td align="right">
//                                   {numberWithCommas(
//                                     parseFloat(data?.total_amount || 0).toFixed(
//                                       4
//                                     )
//                                   )}
//                                 </td>
//                                 <td align="right">
//                                   {numberWithCommas(
//                                     parseFloat(
//                                       data?.unredeem_value || 0
//                                     ).toFixed(4)
//                                   )}
//                                 </td>
//                                 <td align="right">
//                                   {/* {data?.days_of_maturity || 0} */}
//                                   {daysofMaturity || 0}
//                                 </td>
//                                 <td align="center">{data?.coupon_days}</td>

//                                 <td align="right">
//                                   {numberWithCommas(
//                                     parseFloat(
//                                       data?.coupon_payment || 0
//                                     ).toFixed(4)
//                                   )}
//                                 </td>
//                                 <td align="right">
//                                   {numberWithCommas(
//                                     parseFloat(data?.yield || 0)?.toFixed(4)
//                                   )}
//                                 </td>
//                                 <td align="right">
//                                   <NumberFormat
//                                     thousandSeparator
//                                     decimalScale={2}
//                                     isAllowed={(values) => {
//                                       const { value } = values;
//                                       let returnVal;
//                                       if (
//                                         (+value <= 100 && +value > 0) ||
//                                         value === ""
//                                       ) {
//                                         returnVal = true;
//                                       } else {
//                                         returnVal = false;
//                                       }
//                                       return returnVal;
//                                     }}
//                                     disabled={disableCoupanRateArr?.includes(
//                                       data?.security_type
//                                     )}
//                                     value={data.coupon_rate || ""}
//                                     className="form-control py-0 w-75 d-inline-block"
//                                     placeholder="0.00"
//                                     onValueChange={({ value }) => {
//                                       if (
//                                         !value ||
//                                         /^(\d+(\.\d{0,4})?)?$/.test(value)
//                                       ) {
//                                         const num = parseFloat(value);
//                                         if (num >= 0 && num <= 100) {
//                                           updateCouponRate(index, value);
//                                         }
//                                       }
//                                     }}
//                                     onBlur={() => {
//                                       const num = parseFloat(
//                                         data.coupon_rate || "0"
//                                       );
//                                       if (!isNaN(num)) {
//                                         updateCouponRate(index, num.toFixed(4));
//                                       }
//                                     }}
//                                   />
//                                 </td>

//                                 {/* <td align="right">
//                                   {numberWithCommas(
//                                     parseFloat(data?.mmface_value || 0).toFixed(4)
//                                   )}
//                                 </td> */}

//                                 {/* <td align="right">
//                                   {numberWithCommas(
//                                     parseFloat(
//                                       data?.average_cost_per_unit || 0
//                                     ).toFixed(4)
//                                   )}
//                                 </td> */}

//                                 {/* <td align="right">
//                                   {numberWithCommas(
//                                     parseFloat(
//                                       data?.market_rate_per_unit || 0
//                                     ).toFixed(4)
//                                   )}
//                                 </td>
//                                 <td align="right">
//                                   {numberWithCommas(
//                                     parseFloat(data?.market_value || 0).toFixed(4)
//                                   )}
//                                 </td>
//                                 <td align="right">
//                                   {numberWithCommas(
//                                     parseFloat(
//                                       data?.unrealized_gain_loss || 0
//                                     ).toFixed(4)
//                                   )}
//                                 </td>
//                                 <td align="right">
//                                   {numberWithCommas(
//                                     parseFloat(
//                                       data?.investment_percentage_market_value || 0
//                                     ).toFixed(4)
//                                   )}
//                                 </td> */}
//                                 <td className="text-center">
//                                   <div className="d-flex">
//                                     <ReactTooltip
//                                       textColor="white"
//                                       backgroundColor="black"
//                                       effect="float"
//                                     />
//                                     <button
//                                       data-tip="Remove"
//                                       onClick={() =>
//                                         removeSecurityAtIndex(index)
//                                       }
//                                       type="button"
//                                       className="btn-icon btn-link like btn btn-danger btn-sm"
//                                     >
//                                       <i className="tim-icons icon-simple-remove"></i>
//                                     </button>
//                                     {/* <div
//                                     className="text-danger table-hover:text-dark"
//                                     onClick={() => removeSecurityAtIndex(index)}
//                                     style={{
//                                       fontSize: "1.2rem",
//                                       padding: "0.1rem 0.4rem",
//                                       cursor: "pointer",
//                                     }}
//                                     aria-label="Remove security"
//                                   >
//                                     <BsX />
//                                   </div> */}
//                                     <ReactTooltip
//                                       textColor="white"
//                                       backgroundColor="black"
//                                       effect="float"
//                                     />
//                                     <button
//                                       data-tip="View All Details"
//                                       type="button"
//                                       className="btn-icon btn-link like btn btn-primary btn-sm"
//                                       onClick={() => {
//                                         setModalViewMM(true);
//                                         setSelectedItem({
//                                           ...data,
//                                           daysofMaturity,
//                                         });
//                                       }}
//                                     >
//                                       <i className="fa fa-list"></i>
//                                     </button>
//                                   </div>
//                                 </td>
//                               </tr>
//                             );
//                           })}
//                         </tbody>
//                       </Table>
//                     ) : (
//                       StockMarketData()
//                     )}
//                   </CardBody>
//                 </Card>
//               )}

//               {/* Affected Ledgers */}
//               {affectedLedgerData.length > 0 && tableData.length > 0 && (
//                 <Card className="mt-3">
//                   <CardHeader>
//                     <h4 className="card-title">Affected Ledgers</h4>
//                   </CardHeader>
//                   <CardBody>
//                     <Table responsive>
//                       <thead>
//                         <tr>
//                           <th>Ledger Code</th>
//                           <th>Ledger Name</th>
//                           <th>Family Name</th>
//                           <th>Description</th>
//                           <th className="text-right">Debit</th>
//                           <th className="text-right">Credit</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {affectedLedgerData.map((data, index) => (
//                           <tr key={index}>
//                             <td>{data.gl_code}</td>
//                             <td>{data.gl_name}</td>
//                             <td>{data.family_name}</td>
//                             <td>{data.description}</td>
//                             <td align="right">
//                               {numberWithCommas(
//                                 parseFloat(data.debit_amount || "0")
//                               )}
//                             </td>
//                             <td align="right">
//                               {numberWithCommas(
//                                 parseFloat(data.credit_amount || "0")
//                               )}
//                             </td>
//                           </tr>
//                         ))}
//                       </tbody>
//                     </Table>
//                   </CardBody>
//                 </Card>
//               )}

//               {affectedLedgerData.length > 0 && tableData.length > 0 && (
//                 <Row>
//                   <Col>
//                     <div className="row">
//                       <div className="col-md-6" data-tip="Calculate accrual">
//                         <button
//                           className="btn btn-primary"
//                           disabled={loading || sendingLedgers.length === 0}
//                           onClick={handleSubmit}
//                         >
//                           {loading ? (
//                             <>
//                               <span
//                                 className="spinner-border spinner-border-sm"
//                                 role="status"
//                                 aria-hidden="true"
//                               ></span>
//                               <span> Loading...</span>
//                             </>
//                           ) : (
//                             <span>Calculate Accrual</span>
//                           )}
//                         </button>
//                         <ReactTooltip
//                           textColor="white"
//                           backgroundColor="black"
//                           effect="float"
//                         />
//                       </div>
//                     </div>
//                   </Col>
//                 </Row>
//               )}

//               {loading && <div className="text-center mt-3">Loading...</div>}
//             </Container>
//           </Col>
//         </Row>
//       </div>
//     </>
//   );
// };

// export default DailyPortfolioAccrual;
// DailyPortfolioAccrual.jsx
import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardHeader,
  CardBody,
  Table,
} from "reactstrap";
import Select from "react-select";
import moment from "moment";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useCustomStylesDropDown } from "../assets/css/customStyle";
import NumberFormat from "react-number-format";
import ReactTooltip from "react-tooltip";
import { useSelector } from "react-redux";
import { SecurityArr } from "../utils/ui_data";
import usePortfolioAccrual from "./daily-fund-accrual/usePortfolioAccural";

const DailyPortfolioAccrual = () => {
  const email = sessionStorage.getItem("email") || "";
  const amc_code = sessionStorage.getItem("amc_code") || "";
  const {
    loading,
    accFundLoading,
    allFunds,
    fund,
    setFund,
    date,
    portfolioDate,
    handleDateChange,
    tableData,
    calculations,
    affectedLedgerData,
    sendingLedgers,
    fundCheck,
    todayPIBTotal,
    todayTBILLTotal,
    todayTFCTotal,
    todaySUKUKTotal,
    finalPIB,
    finalTBILL,
    finalTFC,
    finalSUKUK,
    stockMarketTotal,
    finalStockMarket,
    handleGet,
    resetState,
    selectedMarketVal,
    setSelectedMarket,
    selectedMarket,
    handleSubmit,
    renderFundsDropdown,
    selectedFundName,
    numberWithCommas,
    updateCouponRate,
    removeSecurityAtIndex,
    handlePortfolioDate,
  } = usePortfolioAccrual(email, amc_code);
  const theme = useSelector((state: any) => state.ThemeModeReducer.Theme);

  const disableCoupanRateArr = ["PIB", "TBILL", "TDR", "LOP", "CP", "CDR"];

  const { customStyles } = useCustomStylesDropDown();

  const StockMarketData = () => {
    return (
      <Table responsive>
        <thead className="text-nowrap">
          <tr>
            <td colSpan={5}>Fund Code: &nbsp; &nbsp; {fund}</td>
            <td colSpan={5}>AMC Code: &nbsp; &nbsp; {amc_code}</td>
          </tr>
          <tr>
            <th>Code</th>
            <th>Market</th>
            <th className="text-right">Amount</th>
            <th className="text-right">Average Cost/Unit</th>
            <th className="text-right">Investment % Market Value</th>
            <th className="text-right">Market Rate/Unit</th>
            <th className="text-right">Market Value</th>
            <th className="text-right">Total Units</th>
            <th className="text-right">Unit</th>
            <th className="text-right">Unrealized Gain/Loss</th>
            <th className="text-center">Action</th>
          </tr>
        </thead>
        <tbody>
          {tableData.map((data: any, index) => (
            <tr key={index} className="text-nowrap">
              <td>{data?.code}</td>
              <td>{data?.market}</td>
              <td className="text-right">
                {numberWithCommas(parseFloat(data?.amount || 0).toFixed(4))}
              </td>
              <td className="text-right">
                {numberWithCommas(
                  parseFloat(data?.average_cost_per_unit || 0).toFixed(4)
                )}
              </td>
              <td className="text-right">
                {numberWithCommas(
                  parseFloat(
                    data?.investment_percentage_market_value || 0
                  )?.toFixed(4)
                )}
              </td>
              <td className="text-right">
                {numberWithCommas(
                  parseFloat(data?.market_rate_per_unit || 0)?.toFixed(4)
                )}
              </td>
              <td className="text-right">
                {numberWithCommas(
                  parseFloat(data?.market_value || 0).toFixed(4)
                )}
              </td>
              <td className="text-right">
                {numberWithCommas(
                  parseFloat(data?.total_units || 0).toFixed(4)
                )}
              </td>
              <td className="text-right">
                {numberWithCommas(parseFloat(data?.unit || 0).toFixed(4))}
              </td>
              <td className="text-right">
                {numberWithCommas(
                  parseFloat(data?.unrealized_gain_loss || 0).toFixed(4)
                )}
              </td>
              <td className="text-center">
                <ReactTooltip
                  textColor="white"
                  backgroundColor="black"
                  effect="float"
                />
                <button
                  data-tip="Remove"
                  onClick={() => removeSecurityAtIndex(index)}
                  type="button"
                  className="btn-icon btn-link like btn btn-danger btn-sm"
                >
                  <i className="tim-icons icon-simple-remove"></i>
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    );
  };

  const [modalViewMM, setModalViewMM] = useState(false);
  const [selectedItem, setSelectedItem] = useState<any>();

  return (
    <>
      <ToastContainer />
      <div className="content">
        {/* --------------------- Modal to View All Details MM ------------------- */}
        <Modal
          className=""
          dialogClassName="modal90w"
          show={modalViewMM}
          size="lg"
          backdrop={true}
          onHide={() => {
            setModalViewMM(false);
          }}
        >
          <div className="modal-header ">
            <button
              aria-hidden={true}
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => {
                setModalViewMM(false);
              }}
            >
              <i className="tim-icons icon-simple-remove" />
            </button>
            <h6 className="title title-up">View Money Market Security</h6>
          </div>
          <div className="modal-body">
            {selectedItem && (
              <div>
                <table className="table ">
                  <tbody>
                    <tr>
                      <td
                        className="font-weight-bold text-left"
                        style={{ width: "25%" }}
                      >
                        Security Type:
                      </td>
                      <td>{selectedItem.security_type}</td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold text-left">
                        Investment Type:
                      </td>
                      <td>{selectedItem.investment_type}</td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold text-left">Type:</td>
                      <td>{selectedItem.type}</td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold text-left">Symbol:</td>
                      <td>{selectedItem.symbol}</td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold text-left">Name:</td>
                      <td>{selectedItem.name}</td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold text-left">
                        Issue Date:
                      </td>
                      <td>
                        {selectedItem.issue_date
                          ? moment(selectedItem.issue_date).format("DD-MM-YYYY")
                          : ""}
                      </td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold text-left">
                        Maturity Date:
                      </td>
                      <td>
                        {selectedItem.maturity_date
                          ? moment(selectedItem.maturity_date).format(
                              "DD-MM-YYYY"
                            )
                          : ""}
                      </td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold text-left">
                        Face Value:
                      </td>
                      <td>
                        {numberWithCommas(
                          Number(
                            selectedItem?.money_market_face_value || 0
                          ).toFixed(2)
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold text-left">Price:</td>
                      <td>
                        {numberWithCommas(
                          Number(selectedItem?.price || 0).toFixed(2)
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold text-left">Units:</td>
                      <td>
                        {numberWithCommas(
                          Number(selectedItem?.units || 0).toFixed(4)
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold text-left">Yield:</td>
                      <td>
                        {numberWithCommas(
                          Number(selectedItem?.yield || 0).toFixed(2)
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold text-left">
                        Coupon Rate:
                      </td>
                      <td>
                        {numberWithCommas(
                          Number(selectedItem?.coupon_rate || 0).toFixed(2)
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold text-left">
                        Next Coupon Date:
                      </td>
                      <td>
                        {selectedItem.next_coupon_date === ""
                          ? ""
                          : moment(selectedItem.next_coupon_date).format(
                              "DD-MM-YYYY"
                            )}
                      </td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold text-left">
                        Last Coupon Date:
                      </td>
                      <td>
                        {selectedItem.last_coupon_date === ""
                          ? ""
                          : moment(selectedItem.last_coupon_date).format(
                              "DD-MM-YYYY"
                            )}
                      </td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold text-left">
                        Primary Dealer:
                      </td>
                      <td>{selectedItem.primary_dealer}</td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold text-left">
                        Fund IPS Account:
                      </td>
                      <td>{selectedItem.fund_ips_account}</td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold text-left">
                        Counter Party IPS Account:
                      </td>
                      <td>{selectedItem.counter_party_ips_account}</td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold text-left">
                        Broker Name:
                      </td>
                      <td>{selectedItem.broker_name}</td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold text-left">
                        Settlement Amount:
                      </td>
                      <td>
                        {numberWithCommas(
                          Number(selectedItem?.settlement_amount || 0).toFixed(
                            2
                          )
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold text-left">
                        Total Face Value:
                      </td>
                      <td>
                        {numberWithCommas(
                          Number(selectedItem?.total_face_value || 0).toFixed(2)
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold text-left">
                        Accrued Amount:
                      </td>
                      <td>
                        {numberWithCommas(
                          Number(selectedItem?.accrued_amount || 0).toFixed(2)
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold text-left">Brokerage:</td>
                      <td>{selectedItem.brokerage}</td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold text-left">
                        Premium Discount:
                      </td>
                      <td>
                        {numberWithCommas(
                          Number(selectedItem?.premium_discount || 0).toFixed(2)
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold text-left">
                        Accrued Days:
                      </td>
                      <td>{selectedItem.accrued_days}</td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold text-left">
                        Counter Party Name:
                      </td>
                      <td>{selectedItem.counter_party_name}</td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold text-left">Detail:</td>
                      <td>{selectedItem.detail}</td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold text-left">
                        Principal Amount:
                      </td>
                      <td>
                        {numberWithCommas(
                          Number(selectedItem?.principal_amount || 0).toFixed(2)
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold text-left">
                        UnRedeem Value:
                      </td>
                      <td>
                        {numberWithCommas(
                          Number(selectedItem?.unredeem_value || 0).toFixed(2)
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold text-left">
                        Coupon Payment/Year:
                      </td>
                      <td>
                        {numberWithCommas(
                          Number(selectedItem?.coupon_payment || 0).toFixed(2)
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold text-left">
                        Days of Maturity:
                      </td>
                      <td>{selectedItem?.daysofMaturity || 0}</td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold text-left">
                        Avg Cost/Unit:
                      </td>
                      <td>
                        {numberWithCommas(
                          Number(
                            selectedItem?.average_cost_per_unit || 0
                          ).toFixed(4)
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold text-left">
                        Avg Cost Amt:
                      </td>
                      <td>
                        {numberWithCommas(
                          Number(
                            selectedItem?.average_cost_amount || 0
                          ).toFixed(2)
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold text-left">
                        Gain/Loss Per Unit:
                      </td>
                      <td>
                        {numberWithCommas(
                          Number(selectedItem?.gain_loss_per_unit || 0).toFixed(
                            4
                          )
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold text-left">
                        Gain/Loss Amt:
                      </td>
                      <td>
                        {numberWithCommas(
                          Number(selectedItem?.gain_loss_amount || 0).toFixed(2)
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </Modal>

        <Row>
          <Col md="12">
            <Container fluid>
              <Card className="mt-3">
                <CardHeader>
                  <h4 className="card-title text-primary">
                    Daily Portfolio Accrual
                  </h4>
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col md="4">
                      <label htmlFor="fund">Select Fund</label>
                      {accFundLoading ? (
                        <div className="form-control w-100">
                          <i className="fa fa-spinner fa-spin fa-1x"></i>
                          Fetching Funds...
                        </div>
                      ) : (
                        <Select
                          className="react-select info"
                          classNamePrefix="react-select"
                          options={renderFundsDropdown}
                          value={selectedFundName}
                          onChange={(selectedOption) => {
                            setSelectedMarket("");
                            setFund(selectedOption?.value || "");
                          }}
                          isLoading={accFundLoading}
                          isDisabled={accFundLoading || fundCheck}
                          isClearable={true}
                          styles={customStyles}
                        />
                      )}
                      {fundCheck && (
                        <p className="text-danger">No funds available.</p>
                      )}
                    </Col>
                    <Col md="4">
                      <label htmlFor="fund">Select Market</label>
                      <Select
                        className="react-select info"
                        classNamePrefix="react-select"
                        options={SecurityArr}
                        value={selectedMarketVal}
                        onChange={(selectedOption) => {
                          resetState();
                          setSelectedMarket(selectedOption?.value || "");
                        }}
                        isClearable={true}
                        styles={customStyles}
                      />
                    </Col>
                    <Col md="4">
                      <label htmlFor="date">Settlement Date</label>
                      <input
                        style={{
                          colorScheme: theme,
                        }}
                        type="date"
                        className="form-control"
                        value={date}
                        onChange={handleDateChange}
                        max={moment().format("YYYY-MM-DD")}
                      />
                    </Col>
                    <Col md="4">
                      <label htmlFor="date">Portfolio Date</label>
                      <input
                        type="date"
                        style={{
                          colorScheme: theme,
                        }}
                        className="form-control"
                        value={portfolioDate}
                        onChange={handlePortfolioDate}
                        max={moment().format("YYYY-MM-DD")}
                      />
                    </Col>
                    <Col md="4" className="mt-4">
                      <Button
                        className="btn btn-primary"
                        onClick={handleGet}
                        disabled={
                          loading || accFundLoading || !fund || !selectedMarket
                        }
                      >
                        {loading ? (
                          <>
                            <span
                              className="spinner-border login-txt spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            <span className="login-txt"> Loading...</span>
                          </>
                        ) : (
                          <span className="text-white">Get Portfolio</span>
                        )}
                      </Button>
                    </Col>
                  </Row>
                </CardBody>
              </Card>

              {/* Portfolio Data Table */}
              {tableData.length > 0 && (
                <Card className="mt-3">
                  <CardHeader>
                    <h4 className="card-title text-primary">
                      Portfolio Data -{" "}
                      {moment(portfolioDate).format("DD-MM-YYYY")}
                    </h4>
                  </CardHeader>
                  <CardBody>
                    {selectedMarket === "money_market" ? (
                      <Table responsive>
                        <thead className="text-nowrap">
                          <tr>
                            <td colSpan={4}>Fund Code: &nbsp; &nbsp; {fund}</td>
                            <td colSpan={4}>
                              AMC Code: &nbsp; &nbsp; {amc_code}
                            </td>
                          </tr>
                          <tr>
                            <th>Symbol</th>
                            <th>Security Type</th>
                            <th>Name</th>
                            <th>Issue Date</th>
                            <th>Maturity Date</th>
                            <th className="text-right">Units</th>
                            <th align="right">Total Face Value</th>
                            <th align="right">Principal Amount</th>
                            <th align="right">Total Cost</th>
                            <th align="right">Unredeem Value</th>
                            <th align="right">Maturity Days</th>
                            <th align="right">Coupon Days</th>
                            <th align="right">Coupon Payment</th>
                            <th align="right">Yield %</th>
                            <th align="right">Coupon Rate %</th>
                            <th align="center">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {tableData.map((data: any, index) => {
                            const maturityMoment = moment(
                              data?.maturity_date
                            ).startOf("day");
                            const currentMoment = moment(date).startOf("day");

                            const daysofMaturity = maturityMoment.diff(
                              currentMoment,
                              "days"
                            );
                            return (
                              <tr key={index} className="text-nowrap">
                                <td>{data?.code}</td>
                                <td>{data?.security_type}</td>
                                <td>
                                  <ReactTooltip
                                    textColor="white"
                                    backgroundColor="black"
                                    effect="float"
                                  />
                                  <div
                                    data-tip={data?.name}
                                    style={{
                                      maxWidth: "80px",
                                    }}
                                    className="text-truncate"
                                  >
                                    {data?.name}
                                  </div>
                                </td>
                                <td>{data?.issue_date}</td>
                                <td>{data?.maturity_date}</td>
                                <td align="right">
                                  {numberWithCommas(
                                    parseFloat(data?.units || 0).toFixed(4)
                                  )}
                                </td>
                                <td align="right">
                                  {numberWithCommas(
                                    parseFloat(
                                      data?.total_face_value || 0
                                    ).toFixed(4)
                                  )}
                                </td>
                                <td align="right">
                                  {numberWithCommas(
                                    parseFloat(
                                      data?.principal_amount || 0
                                    )?.toFixed(4)
                                  )}
                                </td>
                                <td align="right">
                                  {numberWithCommas(
                                    parseFloat(data?.total_amount || 0).toFixed(
                                      4
                                    )
                                  )}
                                </td>
                                <td align="right">
                                  {numberWithCommas(
                                    parseFloat(
                                      data?.unredeem_value || 0
                                    ).toFixed(4)
                                  )}
                                </td>
                                <td align="right">{daysofMaturity || 0}</td>
                                <td align="center">{data?.coupon_days}</td>
                                <td align="right">
                                  {numberWithCommas(
                                    parseFloat(
                                      data?.coupon_payment || 0
                                    ).toFixed(4)
                                  )}
                                </td>
                                <td align="right">
                                  {numberWithCommas(
                                    parseFloat(data?.yield || 0)?.toFixed(4)
                                  )}
                                </td>
                                <td align="right">
                                  <NumberFormat
                                    thousandSeparator
                                    decimalScale={2}
                                    isAllowed={(values) => {
                                      const { value } = values;
                                      let returnVal;
                                      if (
                                        (+value <= 100 && +value > 0) ||
                                        value === ""
                                      ) {
                                        returnVal = true;
                                      } else {
                                        returnVal = false;
                                      }
                                      return returnVal;
                                    }}
                                    disabled={disableCoupanRateArr?.includes(
                                      data?.security_type
                                    )}
                                    value={data.coupon_rate || ""}
                                    className="form-control py-0 w-75 d-inline-block"
                                    placeholder="0.00"
                                    onValueChange={({ value }) => {
                                      if (
                                        !value ||
                                        /^(\d+(\.\d{0,4})?)?$/.test(value)
                                      ) {
                                        const num = parseFloat(value);
                                        if (num >= 0 && num <= 100) {
                                          updateCouponRate(index, value);
                                        }
                                      }
                                    }}
                                    onBlur={() => {
                                      const num = parseFloat(
                                        data.coupon_rate || "0"
                                      );
                                      if (!isNaN(num)) {
                                        updateCouponRate(index, num.toFixed(4));
                                      }
                                    }}
                                  />
                                </td>
                                <td className="text-center">
                                  <div className="d-flex">
                                    <ReactTooltip
                                      textColor="white"
                                      backgroundColor="black"
                                      effect="float"
                                    />
                                    <button
                                      data-tip="Remove"
                                      onClick={() =>
                                        removeSecurityAtIndex(index)
                                      }
                                      type="button"
                                      className="btn-icon btn-link like btn btn-danger btn-sm"
                                    >
                                      <i className="tim-icons icon-simple-remove"></i>
                                    </button>
                                    <ReactTooltip
                                      textColor="white"
                                      backgroundColor="black"
                                      effect="float"
                                    />
                                    <button
                                      data-tip="View All Details"
                                      type="button"
                                      className="btn-icon btn-link like btn btn-primary btn-sm"
                                      onClick={() => {
                                        setModalViewMM(true);
                                        setSelectedItem({
                                          ...data,
                                          daysofMaturity,
                                        });
                                      }}
                                    >
                                      <i className="fa fa-list"></i>
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                    ) : (
                      StockMarketData()
                    )}
                  </CardBody>
                </Card>
              )}

              {/* Accrual Summary Card - NEW */}
              {tableData.length > 0 && (
                <Card className="mt-3">
                  <CardHeader>
                    <h4 className="card-title text-primary">Accrual Summary</h4>
                  </CardHeader>
                  <CardBody>
                    {selectedMarket === "money_market" ? (
                      <Table responsive>
                        <thead>
                          <tr>
                            <th>Security Type</th>
                            <th className="text-right">Daily Accrual Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {finalPIB > 0 && (
                            <tr>
                              <td>PIB</td>
                              <td className="text-right">
                                {numberWithCommas(finalPIB.toFixed(4))}
                              </td>
                            </tr>
                          )}
                          {finalTBILL > 0 && (
                            <tr>
                              <td>TBILL</td>
                              <td className="text-right">
                                {numberWithCommas(finalTBILL.toFixed(4))}
                              </td>
                            </tr>
                          )}
                          {finalTFC > 0 && (
                            <tr>
                              <td>TFC</td>
                              <td className="text-right">
                                {numberWithCommas(finalTFC.toFixed(4))}
                              </td>
                            </tr>
                          )}
                          {finalSUKUK > 0 && (
                            <tr>
                              <td>SUKUK</td>
                              <td className="text-right">
                                {numberWithCommas(finalSUKUK.toFixed(4))}
                              </td>
                            </tr>
                          )}
                          {Object.keys(calculations).map((key) => {
                            if (
                              !["PIB", "TBILL", "TFC", "SUKUK"].includes(key)
                            ) {
                              return (
                                <tr key={key}>
                                  <td>{key}</td>
                                  <td className="text-right">
                                    {numberWithCommas(
                                      calculations[key]?.toFixed(4) || "0.0000"
                                    )}
                                  </td>
                                </tr>
                              );
                            }
                            return null;
                          })}
                        </tbody>
                      </Table>
                    ) : (
                      <Table responsive>
                        <thead>
                          <tr>
                            <th>Portfolio Type</th>
                            <th className="text-right">
                              Total Unrealized Gain/Loss
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Equity Portfolio</td>
                            <td className="text-right">
                              {numberWithCommas(finalStockMarket.toFixed(4))}
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    )}
                  </CardBody>
                </Card>
              )}

              {/* Affected Ledgers Card */}
              {affectedLedgerData.length > 0 && (
                <Card className="mt-3">
                  <CardHeader>
                    <h4 className="card-title text-primary">
                      Affected Ledgers
                    </h4>
                  </CardHeader>
                  <CardBody>
                    <Table responsive>
                      <thead>
                        <tr>
                          <th>GL Code</th>
                          <th>GL Name</th>
                          <th className="text-right">Debit Amount</th>
                          <th className="text-right">Credit Amount</th>
                          <th>Description</th>
                        </tr>
                      </thead>
                      <tbody>
                        {affectedLedgerData.map((ledger, index) => (
                          <tr key={index}>
                            <td>{ledger.gl_code}</td>
                            <td>{ledger.gl_name}</td>
                            <td className="text-right">
                              {numberWithCommas(
                                parseFloat(ledger.debit_amount || "0").toFixed(
                                  4
                                )
                              )}
                            </td>
                            <td className="text-right">
                              {numberWithCommas(
                                parseFloat(ledger.credit_amount || "0").toFixed(
                                  4
                                )
                              )}
                            </td>
                            <td>{ledger.description}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </CardBody>
                </Card>
              )}

              {/* Submit Button */}
              {affectedLedgerData.length > 0 && (
                <Card className="mt-3">
                  <CardBody>
                    <Row>
                      <Col md="12" className="text-right">
                        <Button
                          color="primary"
                          onClick={handleSubmit}
                          disabled={loading || sendingLedgers.length === 0}
                        >
                          {loading ? (
                            <>
                              <span
                                className="spinner-border login-txt spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              <span className="login-txt"> Submitting...</span>
                            </>
                          ) : (
                            <span>Submit Transaction</span>
                          )}
                        </Button>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              )}
            </Container>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default DailyPortfolioAccrual;
